var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 128,
    viewBox: "0 0 136 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 63.123L89.547 56.014L89.548 64.702L89.536 64.703C89.586 71.58 84.592 78.844 74.776 84.511C56.919 94.821 29.905 95.941 14.44 87.012C7.404 82.949 3.983 77.506 4.012 71.809L4 71.81V63.123Z",
    fill: "url(#paint0_linear_203_129)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 71.542L89.547 64.433L89.548 73.121L89.536 73.122C89.586 79.999 84.592 87.263 74.776 92.93C56.919 103.24 29.905 104.359 14.44 95.431C7.404 91.368 3.983 85.925 4.012 80.228L4 80.229V71.542Z",
    fill: "url(#paint1_linear_203_129)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 79.9611L89.547 72.8521L89.548 81.5411L89.536 81.5421C89.586 88.4181 84.592 95.6821 74.776 101.349C56.919 111.659 29.905 112.779 14.44 103.85C7.404 99.7871 3.983 94.3441 4.012 88.6471L4 88.6481V79.9611Z",
    fill: "url(#paint2_linear_203_129)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 71.542L89.547 64.433L89.548 73.121L89.536 73.122C89.586 79.999 84.592 87.263 74.776 92.93C56.919 103.24 29.905 104.359 14.44 95.431C7.404 91.368 3.983 85.925 4.012 80.228L4 80.229V71.542Z",
    fill: "url(#paint3_linear_203_129)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 63.123L89.547 56.014L89.548 64.702L89.536 64.703C89.586 71.58 84.592 78.844 74.776 84.511C56.919 94.821 29.905 95.941 14.44 87.012C7.404 82.949 3.983 77.506 4.012 71.809L4 71.81V63.123Z",
    fill: "url(#paint4_linear_203_129)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 54.703L89.547 47.595L89.548 56.283L89.536 56.284C89.586 63.161 84.592 70.424 74.776 76.092C56.919 86.402 29.905 87.521 14.44 78.593C7.404 74.53 3.983 69.087 4.012 63.39L4 63.391V54.703Z",
    fill: "url(#paint5_linear_203_129)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 46.284L89.547 39.176L89.548 47.864L89.536 47.865C89.586 54.741 84.592 62.005 74.776 67.672C56.919 77.982 29.905 79.102 14.44 70.174C7.404 66.111 3.983 60.667 4.012 54.971L4 54.972V46.284Z",
    fill: "url(#paint6_linear_203_129)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7761 58.985C56.9191 69.295 29.9061 70.415 14.4411 61.486C-1.0239 52.557 0.915097 36.961 18.7731 26.651C36.6301 16.341 63.6431 15.221 79.1081 24.15C94.5731 33.079 92.6341 48.675 74.7761 58.985Z",
    fill: "url(#paint7_linear_203_129)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5959 55.994C55.0419 64.397 33.0259 65.31 20.4209 58.033C7.81694 50.756 9.39794 38.045 23.9519 29.642C38.5059 21.239 60.5229 20.326 73.1269 27.603C85.7309 34.88 84.1509 47.591 69.5959 55.994Z",
    fill: "url(#paint8_linear_203_129)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.205 27.498L113.706 23.208C108.786 20.328 102.352 20.576 95.3111 24.641C79.8461 33.57 67.3091 57.524 67.3091 78.144C67.3091 89.215 70.9241 97.071 76.6651 100.594C76.9641 100.777 85.2961 105.471 85.2961 105.471C101.81 70.649 121.936 27.837 121.205 27.498Z",
    fill: "url(#paint9_linear_203_129)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9971 83.055C75.9971 103.675 88.5331 113.152 103.998 104.224C119.463 95.295 132 71.342 132 50.722C132 30.102 119.463 20.624 103.998 29.553C88.5331 38.481 75.9971 62.435 75.9971 83.055Z",
    fill: "url(#paint10_linear_203_129)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1758 80.065C81.1758 96.871 91.3938 104.595 103.999 97.318C116.603 90.041 126.821 70.518 126.821 53.712C126.821 36.906 116.603 29.182 103.999 36.459C91.3938 43.736 81.1758 63.259 81.1758 80.065Z",
    fill: "url(#paint11_linear_203_129)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5671 41.4785C34.3588 41.5261 37.1282 39.8052 37.6559 37.6414C38.1455 35.6342 36.5176 33.9494 33.8915 33.9252C31.2891 33.9012 28.6528 35.5196 27.9122 37.5143C27.1161 39.6574 28.7932 41.4312 31.5671 41.4785Z",
    fill: "#FAA300"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0261 39.9859C33.7379 40.0124 35.462 38.9491 35.8185 37.6174C36.1581 36.3502 35.1351 35.284 33.4781 35.2665C31.8358 35.2489 30.1667 36.2764 29.7284 37.5379C29.2681 38.8623 30.3126 39.9591 32.0261 39.9859Z",
    fill: "#F69837"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6071 41.993C64.523 42.0434 66.7313 40.2578 66.4494 38.0215C66.1877 35.9444 63.8546 34.2051 61.1274 34.1792C58.4196 34.1537 56.3096 35.8276 56.3032 37.8868C56.2962 40.1049 58.7145 41.9432 61.6071 41.993Z",
    fill: "#FAA300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5119 40.4465C63.3065 40.4749 64.6768 39.3737 64.5367 37.996C64.4032 36.6847 62.9314 35.5832 61.2122 35.5643C59.4987 35.5458 58.1676 36.6088 58.1947 37.9117C58.2238 39.2808 59.7295 40.4184 61.5119 40.4465Z",
    fill: "#F69837"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2384 40.3064C60.4822 39.3542 60.1103 38.3621 60.0691 37.4514C59.8923 33.5354 56.8289 30.1464 52.4552 28.7831L52.5433 27.3521L49.7582 28.1364L49.3851 26.5695C48.3151 26.8184 47.0137 27.3588 45.5949 28.3292C40.1269 29.1799 35.3887 32.7882 34.1237 37.1226C33.8942 37.9098 33.348 38.8865 32.3208 39.8582C30.7979 41.2994 29.8448 42.8341 29.3759 44.2852C27.2468 50.8729 34.5543 56.2534 44.6204 56.5634C54.9517 56.8813 63.6994 51.7357 63.1712 44.9591C63.0495 43.3962 62.4175 41.7903 61.2384 40.3064Z",
    fill: "#FBC280"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2213 46.3578C36.65 44.5313 37.589 42.6943 39.0223 41.0242C39.9397 39.9549 40.4979 38.8192 40.714 37.7607C41.6295 33.2718 45.2435 29.4943 49.7181 27.9701L49.3849 26.5695C48.3155 26.8184 47.0145 27.3582 45.5943 28.3292C40.1267 29.1799 35.3885 32.7882 34.1235 37.1226C33.894 37.9098 33.3475 38.8865 32.3206 39.8582C30.7977 41.2994 29.8445 42.8341 29.3756 44.2852C27.7043 49.456 31.8517 53.9807 38.8729 55.7733C36.4137 53.124 35.4095 49.8173 36.2213 46.3578Z",
    fill: "#FAA300"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9208 54.0783C51.0361 54.2533 56.271 51.2362 56.2787 47.3093C56.28 46.6285 56.1073 45.8592 55.7137 45.1241C55.1985 44.1607 55.391 43.0658 56.2283 42.2978C57.2995 41.3153 57.7885 40.0012 57.4996 38.6564C57.114 36.8602 55.2748 35.3667 52.9459 35.065C51.1855 34.8371 49.5323 35.2735 48.3171 36.0491C48.2313 36.1037 47.7793 36.3926 47.0888 36.3843C46.399 36.3763 46.024 36.0814 45.949 36.022C44.962 35.2457 43.4467 34.7544 41.6193 34.9482C39.2795 35.1959 37.1176 36.6167 36.3106 38.3618C35.6879 39.7088 35.8941 40.9958 36.6659 41.9553C37.2794 42.7176 37.2325 43.7936 36.4865 44.735C35.887 45.4915 35.5631 46.2454 35.4178 46.8449C34.4822 50.7005 38.8962 53.906 44.9208 54.0783Z",
    fill: "#FAEBC8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4181 46.8446C35.1254 48.0506 35.3616 49.2559 36.0948 50.3338C35.8777 49.0701 35.91 47.6857 36.2215 46.3578C36.6502 44.5314 37.5893 42.6943 39.0225 41.024C39.9399 39.9549 40.4982 38.8192 40.714 37.7607C40.8879 36.9088 41.2049 35.926 41.684 34.9441L41.6196 34.9479C39.2798 35.1959 37.1182 36.6167 36.3109 38.3615C35.6881 39.7088 35.8943 40.9959 36.6662 41.9551C37.2797 42.7176 37.2327 43.7934 36.4868 44.735C35.8876 45.4909 35.5636 46.2452 35.4181 46.8446Z",
    fill: "#F5DCB4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7599 44.3229C44.6016 44.3197 44.4899 44.2706 44.4678 44.261L43.2095 43.7049C42.9066 43.5706 42.8255 43.2443 43.0257 42.9954C43.2258 42.7477 43.6465 42.6465 43.9479 42.7786L45.1972 43.3257C45.5056 43.4608 45.5943 43.7902 45.4012 44.0404C45.2671 44.2134 45.0127 44.328 44.7599 44.3229Z",
    fill: "#F59636"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4563 44.3759C47.1948 44.3708 46.974 44.2412 46.8859 44.0691C46.7531 43.81 46.9242 43.4872 47.2647 43.3647L48.6491 42.8642C48.9849 42.7422 49.3811 42.86 49.5206 43.115C49.6613 43.3733 49.4992 43.6954 49.1608 43.8186L47.7637 44.3255C47.74 44.3341 47.6152 44.3791 47.4563 44.3759Z",
    fill: "#F59636"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7022 46.3878C39.2892 46.3788 38.901 46.6731 38.8924 46.9975C38.8234 49.546 41.559 51.5729 45.2132 51.6696C48.8965 51.7673 52.1412 49.8677 52.7014 47.3061C52.7729 46.9777 52.4572 46.6652 52.0321 46.6559C47.922 46.5665 43.8123 46.4771 39.7022 46.3878Z",
    fill: "#FFBD00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1714 50.5905C42.2171 51.2091 43.619 51.6276 45.2131 51.6697C46.776 51.7112 48.2851 51.3824 49.515 50.8044C49.1128 49.3654 47.5794 48.2418 45.6361 48.1965C43.7001 48.1515 41.9129 49.1911 41.1714 50.5905Z",
    fill: "#BD5E26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7728 40.6221C39.7121 40.6049 39.005 39.9141 39.1819 39.1103L39.2885 38.6245C39.4596 37.8457 40.415 37.2018 41.4399 37.2149C42.4719 37.2277 43.1671 37.8996 43.0334 38.6775L42.9497 39.1652C42.8109 39.9751 41.8325 40.639 40.7728 40.6221Z",
    fill: "#FFBD00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4396 37.2148L41.1109 38.8935C41.0327 39.2919 41.3889 39.6347 41.9156 39.6427C42.4407 39.6504 42.9227 39.3213 42.9916 38.9207L43.0331 38.6774C43.1668 37.8995 42.4719 37.2279 41.4396 37.2148Z",
    fill: "#F59636"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1583 38.651C41.5078 38.6561 41.826 38.4282 41.8733 38.177C41.9192 37.9322 41.6984 37.6944 41.3466 37.6899C41.0003 37.6851 40.6833 37.9111 40.6325 38.1601C40.5824 38.4068 40.8036 38.6462 41.1583 38.651Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3818 40.8091C51.3045 40.7919 50.4851 40.0922 50.5467 39.2763L50.5837 38.7841C50.6431 37.9966 51.5152 37.3426 52.559 37.3557C53.6063 37.3691 54.4107 38.049 54.3893 38.838L54.3759 39.3325C54.3535 40.1516 53.4614 40.8267 52.3818 40.8091Z",
    fill: "#FFBD00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5587 37.3556L52.4709 39.0573C52.4505 39.4614 52.8623 39.8083 53.3969 39.8163C53.9319 39.8246 54.3712 39.4898 54.3823 39.0847L54.389 38.838C54.4104 38.0489 53.606 37.369 52.5587 37.3556Z",
    fill: "#F59636"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4834 38.8112C52.8336 38.8163 53.1279 38.5909 53.1394 38.3308C53.1506 38.0735 52.8815 37.8415 52.5336 37.837C52.1789 37.8322 51.8936 38.0636 51.8786 38.3136C51.8632 38.5724 52.133 38.8064 52.4834 38.8112Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2133 51.6697C45.272 51.6713 45.5408 51.6783 45.9487 51.6592L46.079 50.512C46.1151 50.1959 45.8188 49.9224 45.4272 49.9125C45.0371 49.9029 44.6751 50.1596 44.6343 50.4752L44.4858 51.6205C44.8858 51.6611 45.1549 51.6681 45.2133 51.6697Z",
    fill: "#F2AC7D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5042 77.9289C93.2493 76.1979 95.6017 72.4295 95.7277 69.5291C95.8514 66.6854 93.7838 65.7077 91.0766 67.3879C88.3555 69.0763 86.0145 72.8153 85.8257 75.724C85.6337 78.6781 87.7332 79.6767 90.5042 77.9289Z",
    fill: "#FAA300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6127 75.927C92.3216 74.8526 93.7947 72.4936 93.8809 70.6843C93.9659 68.898 92.6721 68.2795 90.9704 69.3387C89.2715 70.396 87.8022 72.7437 87.6917 74.5565C87.5802 76.3864 88.8864 77.0127 90.6127 75.927Z",
    fill: "#F69837"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.786 60.0939C121.431 58.4264 123.551 54.867 123.495 52.1594C123.44 49.5049 121.306 48.6288 118.695 50.2488C116.072 51.8763 113.961 55.4103 113.955 58.1264C113.949 60.8845 116.116 61.7773 118.786 60.0939Z",
    fill: "#FAA300"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.769 58.225C120.416 57.1894 121.743 54.9602 121.715 53.272C121.688 51.6048 120.353 51.0501 118.712 52.0714C117.077 53.0889 115.749 55.3071 115.753 57.0019C115.757 58.7096 117.105 59.2709 118.769 58.225Z",
    fill: "#F69837"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.523 58.2117C117.96 57.5702 117.551 56.5949 117.542 55.2633C117.508 49.9198 114.327 47.3367 109.891 48.1714L109.916 46.011L106.974 49.0055L106.436 46.9427C105.248 48.0675 103.896 49.7411 102.503 52.0528C96.8088 56.8261 92.3942 64.777 92.0636 71.1859C92.0046 72.3314 91.6557 73.8367 90.8753 75.5901C89.6873 78.2595 89.1445 80.5806 89.0388 82.4329C88.5943 90.2376 95.5308 91.9078 104.38 86.1798C113.017 80.5891 120.121 70.1037 120.033 62.7795C120.005 60.5006 119.277 59.0698 118.523 58.2117Z",
    fill: "#FBC280"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8664 80.4401C95.9598 78.2269 96.5111 75.5854 97.6454 72.6909C98.3889 70.7941 98.7425 69.0877 98.7927 67.7165C99.0286 61.2943 102.348 53.8454 106.917 48.7895L106.436 46.9426C105.249 48.0666 103.897 49.7395 102.502 52.0531C96.8088 56.826 92.3942 64.7769 92.0636 71.1859C92.0046 72.3313 91.6557 73.8366 90.8753 75.5901C89.6872 78.2595 89.1445 80.5806 89.0388 82.4329C88.6817 88.6991 93.0903 91.0452 99.5075 88.6764C97.1277 87.4464 95.688 84.6659 95.8664 80.4401Z",
    fill: "#FAA300"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.443 83.4685C109.65 80.1115 113.921 73.8626 113.93 69.5345C113.93 69.3419 113.941 68.2486 113.428 67.3368C112.98 66.5402 113.096 65.1445 113.886 63.6666C114.909 61.754 115.331 59.8433 115.085 58.3787C114.731 56.2692 112.917 55.4966 110.649 56.5419C108.98 57.3113 107.34 58.8649 106.126 60.7409C106.053 60.8546 105.622 61.521 104.939 61.9469C104.407 62.2788 103.997 62.2854 103.772 62.2083C102.732 61.8541 101.141 62.1575 99.2731 63.6164C96.9469 65.433 94.9974 68.5861 94.5216 71.2627C94.1484 73.3641 94.6794 74.6689 95.5353 75.2479C96.2214 75.7117 96.4099 76.9133 95.8431 78.4941C95.7547 78.7413 95.2689 80.0809 95.2089 81.4596C95.0131 85.9519 99.1543 86.8778 104.443 83.4685Z",
    fill: "#FAEBC8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2089 81.4595C95.135 83.1536 95.6986 84.18 96.3795 84.7537C95.7895 82.9295 95.8397 81.0778 95.8665 80.4401C95.96 78.2269 96.5112 75.5854 97.6456 72.6909C98.3891 70.7941 98.7427 69.0874 98.7929 67.7165C98.8317 66.6621 98.9772 65.2388 99.3378 63.5693L99.2731 63.6161C96.9469 65.433 94.9974 68.5857 94.5216 71.2626C94.1484 73.364 94.6794 74.6685 95.5353 75.2476C96.2214 75.7117 96.4102 76.9133 95.8435 78.4937C95.7547 78.7412 95.2689 80.0805 95.2089 81.4595Z",
    fill: "#F5DCB4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.463 72.9638C103.317 73.0563 103.212 73.0676 103.188 73.0702L101.965 73.2005C101.685 73.2302 101.543 72.9376 101.714 72.4962C101.878 72.0741 102.265 71.7091 102.553 71.6788L103.773 71.5494C104.053 71.5194 104.196 71.8105 104.028 72.2502C103.914 72.5473 103.683 72.8248 103.463 72.9638Z",
    fill: "#F59636"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M105.942 71.3927C105.905 71.4161 105.559 71.6352 105.396 71.3836C105.257 71.1695 105.377 70.695 105.691 70.336L106.935 68.9093C107.256 68.5409 107.619 68.4717 107.755 68.677C107.895 68.8888 107.777 69.3605 107.465 69.7185L106.219 71.1493C106.087 71.3005 105.967 71.3769 105.942 71.3927Z",
    fill: "#F59636"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0634 78.3517C98.687 78.591 98.371 79.1501 98.4083 79.511C98.6892 82.2252 101.267 82.8572 104.505 80.7779C107.696 78.729 110.378 74.775 110.793 71.621C110.848 71.203 110.557 71.0379 110.182 71.2762C106.476 73.6346 102.77 75.993 99.0634 78.3517Z",
    fill: "#FFBD00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M100.892 82.0058C101.746 82.0373 102.986 81.7535 104.505 80.778C105.776 79.9618 107.061 78.7697 108.152 77.3518C107.731 76.0094 106.32 75.6817 104.597 76.7817C102.898 77.8661 101.398 80.0417 100.892 82.0058Z",
    fill: "#BD5E26"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2714 71.121C98.2413 71.7694 97.4523 71.3903 97.4943 70.3263L97.5198 69.6747C97.5618 68.6101 98.4187 67.2146 99.4321 66.5813C100.452 65.9439 101.235 66.3196 101.203 67.3662L101.182 68.0118C101.149 69.0773 100.29 70.4801 99.2714 71.121Z",
    fill: "#FFBD00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4321 66.5812L99.3522 68.843C99.3336 69.3715 99.7276 69.56 100.241 69.2376C100.748 68.9191 101.176 68.2188 101.193 67.6887L101.203 67.3661C101.235 66.3195 100.452 65.9435 99.4321 66.5812Z",
    fill: "#F59636"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3638 68.5191C99.6997 68.3085 99.9876 67.8331 99.9993 67.4883C100.011 67.1357 99.7445 67.0163 99.4096 67.226C99.074 67.4359 98.786 67.9111 98.7734 68.2558C98.7605 68.6104 99.0275 68.73 99.3638 68.5191Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M110.305 64.1771C109.288 64.8164 108.49 64.4521 108.505 63.4172L108.514 62.7829C108.53 61.7467 109.352 60.3816 110.351 59.7574C111.357 59.1285 112.15 59.4897 112.144 60.5079L112.14 61.1364C112.133 62.1732 111.309 63.545 110.305 64.1771Z",
    fill: "#FFBD00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M110.351 59.7574L110.328 61.9595C110.322 62.4735 110.721 62.6547 111.227 62.3368C111.727 62.023 112.138 61.3379 112.141 60.822L112.144 60.5082C112.15 59.4897 111.357 59.1285 110.351 59.7574Z",
    fill: "#F59636"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M110.331 61.6445C110.663 61.4364 110.938 60.9714 110.941 60.6364C110.945 60.2935 110.675 60.1783 110.344 60.3854C110.013 60.5925 109.737 61.0573 109.733 61.3929C109.729 61.737 109.999 61.8525 110.331 61.6445Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.505 80.778C104.557 80.7448 104.788 80.5967 105.137 80.3391L105.165 79.0374C105.173 78.6734 104.897 78.5528 104.552 78.7741C104.206 78.9951 103.915 79.4883 103.906 79.8444L103.874 81.1499C104.222 80.9595 104.456 80.8098 104.505 80.778Z",
    fill: "#F2AC7D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_129",
    x1: 16.0607,
    y1: 74.5265,
    x2: 46.085,
    y2: 74.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_129",
    x1: 16.0607,
    y1: 82.9457,
    x2: 46.085,
    y2: 82.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_129",
    x1: 16.0607,
    y1: 91.3651,
    x2: 46.085,
    y2: 91.3651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_129",
    x1: 11.6732,
    y1: 82.9457,
    x2: 76.976,
    y2: 82.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_203_129",
    x1: 16.0607,
    y1: 74.5265,
    x2: 46.085,
    y2: 74.5265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_203_129",
    x1: 11.6732,
    y1: 66.1072,
    x2: 76.976,
    y2: 66.1072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_203_129",
    x1: 16.0607,
    y1: 57.6883,
    x2: 46.085,
    y2: 57.6883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_203_129",
    x1: 3.39422,
    y1: 67.848,
    x2: 13.8478,
    y2: 13.5908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_203_129",
    x1: 11.4179,
    y1: 63.2151,
    x2: 19.9379,
    y2: 18.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_203_129",
    x1: 81.9199,
    y1: 73.55,
    x2: 103.27,
    y2: 36.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_203_129",
    x1: 103.998,
    y1: 116.981,
    x2: 103.998,
    y2: 32.5972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_203_129",
    x1: 103.999,
    y1: 107.716,
    x2: 103.999,
    y2: 38.9403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.80b34970e91741b51e690370803db1c5.svg";
export { ForwardRef as ReactComponent };